export default {"src":"/_next/static/media/empty-state-publications.7f5ba861.svg","height":94,"width":72,"blurWidth":0,"blurHeight":0};